import AwsTokenModel from '../../models/AwsTokenModel';
import { SET_AWS_TOKEN, CLEAR_AWS_TOKEN } from '../actions';

const INITIAL_STATE = AwsTokenModel();

export default function awsTokenReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_AWS_TOKEN:
      return { ...state, ...action.payload };
    case CLEAR_AWS_TOKEN: ;
      return { ...INITIAL_STATE };
    default:
      return state;
  }
}
